import { Quote, Video } from "lucide-react";
import PageHeroBackground from "@/components/PageHeroBackground";

// Placeholder slots — layout stays; swap `null` for a real video entry when ready.
// Each slot supports: { videoUrl, thumbnail, speaker, title, summary, size }
const SLOTS = [
  { size: "wide" },
  { size: "square" },
  { size: "tall" },
  { size: "square" },
  { size: "wide" },
];

function PlaceholderCard({ size }) {
  return (
    <div
      data-testid="testimony-placeholder"
      className="group h-full"
    >
      <div className="relative overflow-hidden rounded-2xl bg-[#F3F2EB] border border-dashed border-[#123F33]/20 aspect-video flex items-center justify-center">
        <div className="flex flex-col items-center gap-3 text-[#123F33]/60">
          <div className="w-14 h-14 rounded-full bg-white/70 flex items-center justify-center">
            <Video className="w-6 h-6" strokeWidth={1.6} />
          </div>
          <div className="text-[10px] tracking-[0.24em] uppercase font-semibold">Video coming soon</div>
        </div>
      </div>
      <div className="mt-5">
        <div className="h-3 w-24 rounded-full bg-[#0B1D2E]/10 mb-3" />
        <div className="h-2.5 w-full max-w-xs rounded-full bg-[#0B1D2E]/5" />
      </div>
    </div>
  );
}

export default function Testimonies() {
  return (
    <div data-testid="testimonies-page">
      {/* HERO */}
      <section className="relative pt-40 pb-16 bg-[#FAFAF7] overflow-hidden">
        <PageHeroBackground opacity={0.22} />
        <div className="relative max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
          <div className="max-w-3xl">
            <div className="text-xs uppercase tracking-[0.28em] text-[#123F33] mb-6 font-semibold">Real Lives · Real Change</div>
            <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl text-[#0B1D2E] leading-[1.05] tracking-tight">
              Stories only God
              <span className="block italic text-[#123F33]">could write.</span>
            </h1>
            <p className="mt-8 text-lg text-[#4A5562] leading-relaxed">
              The Gospel isn't theory. It's the power of God to save. Video testimonies from our church family are coming soon — check back to hear how Jesus is still changing lives in DeLand.
            </p>
          </div>
        </div>
      </section>

      {/* FEATURED QUOTE */}
      <section className="bg-white py-16" data-testid="featured-quote-section">
        <div className="max-w-4xl mx-auto px-6 md:px-12 lg:px-16">
          <Quote className="w-10 h-10 text-[#123F33] mb-6" />
          <blockquote className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#0B1D2E] leading-[1.15] italic">
            "Therefore, if anyone is in Christ, the new creation has come: The old has gone, the new is here."
          </blockquote>
          <div className="mt-8 text-sm tracking-[0.22em] uppercase text-[#4A5562]">— 2 Corinthians 5:17</div>
        </div>
      </section>

      {/* PLACEHOLDER GRID */}
      <section className="bg-[#F3F2EB] py-24" data-testid="testimonies-grid-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
          <div className="grid grid-cols-1 md:grid-cols-6 gap-6 md:gap-8">
            {SLOTS.map((s, i) => {
              const span =
                s.size === "wide"
                  ? "md:col-span-4"
                  : s.size === "tall"
                  ? "md:col-span-2 md:row-span-2"
                  : "md:col-span-2";
              return (
                <div key={i} className={span} data-testid={`testimony-slot-${i}`}>
                  <PlaceholderCard size={s.size} />
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* SHARE YOUR STORY */}
      <section className="bg-[#0B1D2E] py-24" data-testid="share-story-section">
        <div className="max-w-5xl mx-auto px-6 md:px-12 lg:px-16 text-center">
          <div className="text-xs uppercase tracking-[0.28em] text-[#E4E1D8] mb-4 font-semibold">Your Story Matters</div>
          <h2 className="font-serif text-4xl sm:text-5xl text-white leading-tight">
            God's working in <span className="italic text-[#E4E1D8]">your life too.</span>
          </h2>
          <p className="mt-6 text-lg text-white/80 max-w-2xl mx-auto leading-relaxed">
            If Jesus has changed your life — we'd love to hear it. Share your story with us the next time you visit.
          </p>
        </div>
      </section>
    </div>
  );
}
